// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Full protocol entity.
 */
export class Protocol implements flatbuffers.IUnpackableObject<ProtocolT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Protocol {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsProtocol(bb: flatbuffers.ByteBuffer, obj?: Protocol): Protocol {
    return (obj || new Protocol()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsProtocol(bb: flatbuffers.ByteBuffer, obj?: Protocol): Protocol {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Protocol()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * JSON-encoded default interface configuration.
   */
  defaultInterfaceJson(): string | null;
  defaultInterfaceJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  defaultInterfaceJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * JSON-encoded CDO interface template.
   */
  cdoInterfaceJson(): string | null;
  cdoInterfaceJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cdoInterfaceJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Binary `FlatBuffer`-encoded default interface.
   */
  defaultInterfaceBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  defaultInterfaceBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  defaultInterfaceBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  /**
   * Binary `FlatBuffer`-encoded CDO interface.
   */
  cdoInterfaceBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  cdoInterfaceBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  cdoInterfaceBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startProtocol(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addDefaultInterfaceJson(
    builder: flatbuffers.Builder,
    defaultInterfaceJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, defaultInterfaceJsonOffset, 0);
  }

  static addCdoInterfaceJson(
    builder: flatbuffers.Builder,
    cdoInterfaceJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(3, cdoInterfaceJsonOffset, 0);
  }

  static addDefaultInterfaceBinary(
    builder: flatbuffers.Builder,
    defaultInterfaceBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(4, defaultInterfaceBinaryOffset, 0);
  }

  static createDefaultInterfaceBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDefaultInterfaceBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCdoInterfaceBinary(
    builder: flatbuffers.Builder,
    cdoInterfaceBinaryOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(5, cdoInterfaceBinaryOffset, 0);
  }

  static createCdoInterfaceBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCdoInterfaceBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, deletedAtOffset, 0);
  }

  static endProtocol(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createProtocol(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    defaultInterfaceJsonOffset: flatbuffers.Offset,
    cdoInterfaceJsonOffset: flatbuffers.Offset,
    defaultInterfaceBinaryOffset: flatbuffers.Offset,
    cdoInterfaceBinaryOffset: flatbuffers.Offset,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Protocol.startProtocol(builder);
    Protocol.addId(builder, idOffset);
    Protocol.addName(builder, nameOffset);
    Protocol.addDefaultInterfaceJson(builder, defaultInterfaceJsonOffset);
    Protocol.addCdoInterfaceJson(builder, cdoInterfaceJsonOffset);
    Protocol.addDefaultInterfaceBinary(builder, defaultInterfaceBinaryOffset);
    Protocol.addCdoInterfaceBinary(builder, cdoInterfaceBinaryOffset);
    Protocol.addCreatedAt(builder, createdAtOffset);
    Protocol.addUpdatedAt(builder, updatedAtOffset);
    Protocol.addDeletedAt(builder, deletedAtOffset);
    return Protocol.endProtocol(builder);
  }

  unpack(): ProtocolT {
    return new ProtocolT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.defaultInterfaceJson(),
      this.cdoInterfaceJson(),
      this.bb!.createScalarList<number>(
        this.defaultInterfaceBinary.bind(this),
        this.defaultInterfaceBinaryLength(),
      ),
      this.bb!.createScalarList<number>(
        this.cdoInterfaceBinary.bind(this),
        this.cdoInterfaceBinaryLength(),
      ),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: ProtocolT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.defaultInterfaceJson = this.defaultInterfaceJson();
    _o.cdoInterfaceJson = this.cdoInterfaceJson();
    _o.defaultInterfaceBinary = this.bb!.createScalarList<number>(
      this.defaultInterfaceBinary.bind(this),
      this.defaultInterfaceBinaryLength(),
    );
    _o.cdoInterfaceBinary = this.bb!.createScalarList<number>(
      this.cdoInterfaceBinary.bind(this),
      this.cdoInterfaceBinaryLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): ProtocolT {
    const t = new ProtocolT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("default_interface_json")) {
      t.defaultInterfaceJson = this.defaultInterfaceJson();
    }
    if (fieldSet.has("cdo_interface_json")) {
      t.cdoInterfaceJson = this.cdoInterfaceJson();
    }
    if (fieldSet.has("default_interface_binary")) {
      t.defaultInterfaceBinary = this.bb!.createScalarList<number>(
        this.defaultInterfaceBinary.bind(this),
        this.defaultInterfaceBinaryLength(),
      );
    }
    if (fieldSet.has("cdo_interface_binary")) {
      t.cdoInterfaceBinary = this.bb!.createScalarList<number>(
        this.cdoInterfaceBinary.bind(this),
        this.cdoInterfaceBinaryLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class ProtocolT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public defaultInterfaceJson: string | Uint8Array | null = null,
    public cdoInterfaceJson: string | Uint8Array | null = null,
    public defaultInterfaceBinary: number[] = [],
    public cdoInterfaceBinary: number[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const defaultInterfaceJson =
      this.defaultInterfaceJson !== null ? builder.createString(this.defaultInterfaceJson!) : 0;
    const cdoInterfaceJson =
      this.cdoInterfaceJson !== null ? builder.createString(this.cdoInterfaceJson!) : 0;
    const defaultInterfaceBinary = Protocol.createDefaultInterfaceBinaryVector(
      builder,
      this.defaultInterfaceBinary,
    );
    const cdoInterfaceBinary = Protocol.createCdoInterfaceBinaryVector(
      builder,
      this.cdoInterfaceBinary,
    );
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    return Protocol.createProtocol(
      builder,
      id,
      name,
      defaultInterfaceJson,
      cdoInterfaceJson,
      defaultInterfaceBinary,
      cdoInterfaceBinary,
      createdAt,
      updatedAt,
      deletedAt,
    );
  }

  clone(): ProtocolT {
    const obj = new ProtocolT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.defaultInterfaceJson = this.defaultInterfaceJson;
    obj.cdoInterfaceJson = this.cdoInterfaceJson;
    obj.defaultInterfaceBinary = [...this.defaultInterfaceBinary];
    obj.cdoInterfaceBinary = [...this.cdoInterfaceBinary];
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: ProtocolT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.defaultInterfaceJson !== other.defaultInterfaceJson) return false;
    if (this.cdoInterfaceJson !== other.cdoInterfaceJson) return false;
    if (this.defaultInterfaceBinary.length !== other.defaultInterfaceBinary.length) return false;
    for (let i = 0; i < this.defaultInterfaceBinary.length; i++) {
      if (this.defaultInterfaceBinary[i] !== other.defaultInterfaceBinary[i]) return false;
    }
    if (this.cdoInterfaceBinary.length !== other.cdoInterfaceBinary.length) return false;
    for (let i = 0; i < this.cdoInterfaceBinary.length; i++) {
      if (this.cdoInterfaceBinary[i] !== other.cdoInterfaceBinary[i]) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyProtocol(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
